<section class="insight-stepper">
  @if (!integratedStepper()) {
    <header>
      <div class="steps">
        @for (step of steps; track i; let i = $index) {
          <button
            class="step"
            [attr.data-pendo-id]="'product-step-' + (i + 1)"
            [class.active]="selectedIndex === i"
            [class.visited]="selectedIndex > i || step.hasError || step.interacted"
            [class.error]="step.hasError"
            (click)="onClick(i)"
            [disabled]="saving()">
            <span class="step-number-wrapper">
              <span class="step-number">{{ i + 1 }}</span>
            </span>
            <span class="label">{{ step.label }}</span>
          </button>
        }
      </div>

      <div class="action-area">
        <button
          uikit-button
          min-width
          small
          color="ghost"
          [disabled]="saving()"
          (click)="onClose()">
          {{ 'INSIGHT.GLOBAL.CLOSE' | transloco }}
        </button>
      </div>
    </header>
  }
  <div class="step-content">
    @if (integratedStepper()) {
      <forma-card>
        <div class="stepper-wrapper">
          @if (steps.length > 1) {
            <div class="stepper-header">
              <div class="steps">
                @for (step of steps; track step; let i = $index; let isLast = $last) {
                  <forma-step-button
                    [appearance]="'small'"
                    [index]="i + 1"
                    [label]="step.label"
                    [isActive]="selectedIndex === i"
                    [hideProgressBar]="isLast"
                    (click)="onClick(i)"
                    [progress]="step.completed && i <= furthestVisitedStep() ? 100 : 0" />
                }
              </div>
            </div>
          } @else if (!!title()) {
            <div class="stepper-header">
              <h2 class="stepper-title">{{ title() | transloco }}</h2>
            </div>
          }

          <ui-card-content class="stepper-content">
            <ng-container
              [ngTemplateOutlet]="$safeNavigationMigration(selected?.content)"></ng-container>
          </ui-card-content>
          <ui-card-footer>
            <div class="footer-actions-integrated">
              <forma-button-group align="end">
                <button
                  formaButton="text"
                  [disabled]="saving() || isSubmitting()"
                  (click)="cancel()">
                  {{ 'INSIGHT.GLOBAL.CANCEL' | transloco }}
                </button>
                @if (!isEditMode()) {
                  @if (selectedIndex !== 0 && steps.length > 1) {
                    <button
                      cdkStepperPrevious
                      formaButton="secondary"
                      class="footer-prev-button"
                      [disabled]="saving() || selectedIndex === 0"
                      [attr.data-pendo-id]="'insight_stepper_previous'">
                      {{ 'INSIGHT.GLOBAL.PREVIOUS' | transloco }}
                    </button>
                  }
                  @if (selectedIndex !== steps.length - 1) {
                    <button
                      cdkStepperNext
                      formaButton="primary"
                      [disabled]="
                        saving() ||
                        (integratedStepper() && !selected?.completed) ||
                        selectedIndex === steps.length - 1
                      "
                      [attr.data-pendo-id]="'insight_stepper_next'">
                      {{ 'INSIGHT.GLOBAL.NEXT' | transloco }}
                    </button>
                  }
                }
                @if (selectedIndex === steps.length - 1) {
                  <button
                    formaButton="primary"
                    [disabled]="saving() || !isValidToSubmit() || isSubmitting()"
                    [pending]="saving() || isSubmitting()"
                    (click)="saveAndFinishAction()"
                    [attr.data-pendo-id]="'insight_stepper_complete'">
                    {{
                      (isEditMode() && isPaused()
                        ? 'INSIGHT.GLOBAL.RESUME'
                        : isEditMode()
                          ? 'INSIGHT.GLOBAL.SAVESURVEY'
                          : 'INSIGHT.GLOBAL.STARTSURVEY'
                      ) | transloco
                    }}
                  </button>
                }
              </forma-button-group>
            </div>
          </ui-card-footer>
        </div>
      </forma-card>
    } @else {
      <ng-container [ngTemplateOutlet]="$safeNavigationMigration(selected?.content)"></ng-container>
    }
  </div>
  @if (!integratedStepper()) {
    <footer>
      <div class="to-top" [class.visible]="showToTop()">
        <button uikit-square-button size="small" (click)="scrollToTop()" [focusable]="false">
          <uikit-icon icon="chevron-up-thin"></uikit-icon>
          {{ 'INSIGHT.ADMIN.PRODUCTWIZARD.SCROLL_TO_TOP' | transloco }}
        </button>
      </div>

      <div class="footer-content">
        <ng-content select="[stepper-footer]"></ng-content>
      </div>

      <div class="footer-actions">
        <div class="footer-prev-button-container">
          <button
            cdkStepperPrevious
            uikit-button
            min-width
            small
            color="ghost"
            class="footer-prev-button"
            [disabled]="saving() || selectedIndex === 0"
            [attr.data-pendo-id]="'insight_stepper_previous'">
            {{ 'INSIGHT.GLOBAL.PREVIOUS' | transloco }}
          </button>
        </div>
        @if (selectedIndex !== steps.length - 1) {
          <button
            uikit-button
            min-width
            small
            color="ghost"
            [disabled]="saving() || unsaved() === false"
            (click)="onSave()"
            [attr.data-pendo-id]="'insight_stepper_save'">
            {{ 'INSIGHT.GLOBAL.SAVE' | transloco }}
          </button>
          <button
            cdkStepperNext
            uikit-button
            min-width
            small
            color="primary"
            [disabled]="
              saving() || (linear && !selected?.completed) || selectedIndex === steps.length - 1
            "
            [attr.data-pendo-id]="'insight_stepper_next'">
            {{ 'INSIGHT.GLOBAL.NEXT' | transloco }}
          </button>
        } @else {
          @if (selectedIndex === steps.length - 1) {
            <button
              uikit-button
              min-width
              small
              color="primary"
              [disabled]="saving() || !isValidToSubmit()"
              (click)="finishAction()"
              [attr.data-pendo-id]="'insight_stepper_complete'">
              {{ finishButtonText() ?? 'INSIGHT.GLOBAL.COMPLETE' | transloco }}
            </button>
          }
        }
      </div>
    </footer>
  }
</section>
